"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteProperties = exports.getConfiguration = exports.getApplicationPreferences = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _ApplicationContext = require("../ApplicationContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* eslint-disable import/prefer-default-export */

const getConfiguration = (clientId, apiBasePath) => _axios.default.request({
  url: `${apiBasePath}/security/auth/site/config`,
  method: 'get',
  withCredentials: true,
  headers: {
    clientId
  }
});
exports.getConfiguration = getConfiguration;
const getSiteProperties = (siteProps, siteConfiguration) => {
  const tempSiteProps = {
    ...siteProps
  };
  if (siteConfiguration) {
    if (tempSiteProps?.site?.public && !tempSiteProps?.site?.public?.siteMenu) {
      tempSiteProps.site.public.siteMenu = [siteConfiguration.siteMenu];
      _ApplicationContext.ApplicationContext.getSiteDefinition().public.siteMenu = [siteConfiguration.siteMenu];
    }
    if (siteConfiguration?.applicationPreferences) {
      _ApplicationContext.ApplicationContext.setDefaultApplicationPreferences(siteConfiguration.applicationPreferences);
    }
  }
  return tempSiteProps;
};
exports.getSiteProperties = getSiteProperties;
const getApplicationPreferences = (clientId, apiBasePath, customizationId) => {
  _axios.default.request({
    url: `${apiBasePath}/security/auth/application/preferences/get`,
    method: 'get',
    withCredentials: true,
    headers: {
      clientId,
      customizationId
    }
  }).then(applicationPreferences => {
    _ApplicationContext.ApplicationContext.setCurrentApplicationPreferences(applicationPreferences.data);
  }).catch(error => {
    // For now, just swallow the error and let the login button display
  });
};
exports.getApplicationPreferences = getApplicationPreferences;
//# sourceMappingURL=SiteConfiguration.js.map